import type { WidgetDef } from '@/types/dashboardConfig'
import type { DashboardRuntimeSlice } from '@/dashboard/dashboardRuntimeTypes'
import { metricFromSlice } from '@/dashboard/resolveDashboardMetric'

function syntheticValueForWidget(w: WidgetDef): unknown {
  switch (w.type) {
    case 'Gauge':
    case 'ValueCard':
    case 'TrendLine':
      return 42
    case 'StatusBadge':
      return '运行'
    case 'ToggleSwitch':
      return true
    default:
      return '—'
  }
}

/** 为仍无实时值的绑定填入占位，便于组态态 WYSIWYG */
export function mergeSyntheticIntoSlice(
  slice: DashboardRuntimeSlice,
  widgets: WidgetDef[]
): DashboardRuntimeSlice {
  const metrics = { ...slice.metricsBySourceKey }
  for (const w of widgets) {
    const b = w.binding
    if (!b?.sourceKey || !b.field) continue
    const existing = metricFromSlice(slice, b.sourceKey, b.field)
    if (existing !== undefined && existing !== null) continue
    const row = { ...(metrics[b.sourceKey] ?? {}) }
    row[b.field] = syntheticValueForWidget(w)
    metrics[b.sourceKey] = row
  }
  return { ...slice, metricsBySourceKey: metrics }
}
